import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69f19408"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "LoginForm" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "LoginTitle" }, "Welcome Back", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "LoginDescription" }, "Log in your existing account", -1 /* HOISTED */))
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocialIncentiveButtons = _resolveComponent("SocialIncentiveButtons")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_EmailInput = _resolveComponent("EmailInput")!
  const _component_PasswordInput = _resolveComponent("PasswordInput")!
  const _component_GoToForgotPassword = _resolveComponent("GoToForgotPassword")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!
  const _component_RedirectToRegister = _resolveComponent("RedirectToRegister")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_SocialIncentiveButtons, { template: "Big" }),
    _createVNode(_component_Divider),
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
      class: "FgForm"
    }, [
      _createVNode(_component_EmailInput),
      _createVNode(_component_PasswordInput, { autocompletePasswordType: "current-password" }),
      _createVNode(_component_GoToForgotPassword),
      _createVNode(_component_SubmitButton, {
        type: "login",
        onSubmitButtonClicked: _ctx.login
      }, null, 8 /* PROPS */, ["onSubmitButtonClicked"]),
      (_ctx.store.getters.errorMessage().message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.store.getters.errorMessage().message), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ], 32 /* HYDRATE_EVENTS */),
    _createVNode(_component_RedirectToRegister)
  ]))
}